import { render, staticRenderFns } from "./RespuestasComponent.vue?vue&type=template&id=cf40e6b2"
import script from "./RespuestasComponent.vue?vue&type=script&lang=js"
export * from "./RespuestasComponent.vue?vue&type=script&lang=js"
import style0 from "./RespuestasComponent.vue?vue&type=style&index=0&id=cf40e6b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports